import {IndexRedirect, Route} from 'react-router';
import React from 'react';

import checkFeatureFlagStatusOnEnter from 'client/Routing/checkFeatureFlagStatusOnEnter';
import sessionStore from 'client/Session/SessionStore';
import StudentHomepage from './StudentHomepage';

const StudentHomepageRoutes = (
  <Route
    component={StudentHomepage}
    onEnter={(nextState, replace, callback) => {
      if (sessionStore.hasValidSession() && !sessionStore.isStudent()) {
        replace('/classes');
        callback?.();
        return;
      } else {
        return checkFeatureFlagStatusOnEnter('new_student_dashboard', '/classes', 'require')(
          nextState,
          replace,
          callback
        );
      }
    }}
    path='home'
  >
    <IndexRedirect to='assignments' />
    <Route path='assignments(/:classroomId)' component={() => <div>Assignments...</div>} />
    <Route path='skill-path(/:classroomId)' component={() => <div>Skill Path...</div>} />
    <Route
      path='independent-practice(/:classroomId)'
      component={() => <div>Independent Practice...</div>}
    />
  </Route>
);

export default StudentHomepageRoutes;
